import { BookOpen, CalendarClock, Receipt, TrendingUp } from 'lucide-react';
import type { Suggestion } from '../pages/Assistant/AssistantConversation';

/**
 * The four example prompts shown as cards on an empty conversation (and as
 * composer chips), on the full-page assistant and in the docked bubble.
 */
export const ASSISTANT_SUGGESTIONS: Suggestion[] = [
  {
    icon: TrendingUp,
    title: 'How is our MRR trending this quarter?',
    subtitle: 'Trace revenue movement and its drivers',
    chip: 'MRR trend',
    prompt: 'How is our MRR trending this quarter?',
  },
  {
    icon: Receipt,
    title: 'Which clients have overdue invoices?',
    subtitle: 'See who is past due and by how much',
    chip: 'Overdue invoices',
    prompt: 'Which clients have overdue invoices?',
  },
  {
    icon: CalendarClock,
    title: 'Which subscriptions renew in the next 30 days?',
    subtitle: 'Get ahead of the upcoming renewal book',
    chip: 'Upcoming renewals',
    prompt: 'Which subscriptions renew in the next 30 days?',
  },
  {
    icon: BookOpen,
    title: 'How does discount stacking work with custom agreements?',
    subtitle: 'Learn how Revvly applies discounts',
    chip: 'Discount stacking',
    prompt: 'How does discount stacking work with custom agreements?',
  },
];
